import * as React from "react";
const SvgTumourBasedComprehensiveGenomicProfiling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 27"
    {...props}
  >
    <g clipPath="url(#tumour-based-comprehensive-genomic-profiling_svg__a)">
      <path
        stroke={props.invert ? '#FFFFFF' : '#061C57'}
        strokeMiterlimit={10}
        d="M12.01 4.12c1.015 0 1.838-.808 1.838-1.806S13.026.507 12.01.507c-1.015 0-1.838.81-1.838 1.807 0 .998.823 1.806 1.838 1.806ZM21.646 9.727c1.015 0 1.838-.808 1.838-1.806s-.823-1.807-1.839-1.807c-1.015 0-1.838.81-1.838 1.807 0 .998.823 1.806 1.838 1.806ZM21.646 21.083c1.015 0 1.838-.808 1.838-1.806s-.823-1.806-1.839-1.806c-1.015 0-1.838.808-1.838 1.806s.823 1.806 1.838 1.806ZM12.01 26.493c1.015 0 1.838-.81 1.838-1.807 0-.997-.823-1.806-1.838-1.806-1.015 0-1.838.809-1.838 1.806 0 .998.823 1.807 1.838 1.807ZM2.355 21.083c1.015 0 1.838-.808 1.838-1.806s-.823-1.806-1.838-1.806c-1.016 0-1.839.808-1.839 1.806s.823 1.806 1.839 1.806ZM2.355 9.727c1.015 0 1.838-.808 1.838-1.806S3.37 6.114 2.355 6.114c-1.016 0-1.839.81-1.839 1.807 0 .998.823 1.806 1.839 1.806ZM4.193 6.602l6.124-3.588M14.102 2.801l6.046 4.07M2.355 10.103v7.19M4.193 20.49l5.98 3.537M13.849 24.158l6.567-3.82M21.49 17.47l-.036-7.514"
      />
      <path
        stroke={props.invert ? '#FFFFFF' : '#061C57'}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="M12.01 4.272v3.801M12.01 18.836v3.8M16.818 16.05l2.72 2.07M4.193 18.044l3.062-1.73M4.022 8.672l2.763 1.77M19.807 9.2l-1.957 1.207"
      />
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 15.822c1.306 0 2.365-1.041 2.365-2.324 0-1.284-1.059-2.324-2.365-2.324-1.306 0-2.365 1.04-2.365 2.324 0 1.283 1.059 2.324 2.365 2.324Z"
      />
    </g>
    <defs>
      <clipPath id="tumour-based-comprehensive-genomic-profiling_svg__a">
        <path fill="#fff" d="M0 0h24v27H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTumourBasedComprehensiveGenomicProfiling;
